import { Injectable } from '@angular/core';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { LoggerService } from './logger.service';
import { IndexedDbService } from './indexed-db.service';

@Injectable({ providedIn: 'root' })

export class TokenService {
  private refreshing = false;
  private refreshSubject = new BehaviorSubject<string | null>(null);

  constructor(
    private authService: AuthenticationService,
    private logger: LoggerService,
    private db: IndexedDbService
  ) {}

  /** Obtém o token atual (ex: de memory ou secure storage) */
  async getToken(): Promise<string | null> {
    return await this.db.getData('access_token');
  }

  /** Atualiza token apenas uma vez, evita concorrência */
  refreshToken(): Observable<string> {
    if (!this.refreshing) {
      this.refreshing = true;
      this.authService.refreshTokenRequest().subscribe({
        next: async (resp: any) => {
          await this.db.saveData('access_token', resp.access_token);
          await this.db.saveData('refresh_token', resp.refresh_token);
          await this.db.saveData('id_token', resp.id_token);
          this.refreshing = false;
          this.refreshSubject.next(resp.id_token);
        },
        error: () => {
          this.refreshing = false;
          this.refreshSubject.next(null);
        }
      });
    }

    return this.refreshSubject.asObservable().pipe(
      filter(token => token !== null),
      take(1)
    );
  }
}
